import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from "@azure/msal-browser";
import { msalConfig, protectedResources } from "./authconfig";
import ReactGA from 'react-ga4';
import APIUrls from './components/_api/APIUrls';


const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// This callback runs outside the React tree (before the MsalProvider mounts), so it
// can't use the useAnalyticsEventTracker hook -- it mirrors that hook's Prod-only gating directly.
const trackAuthEvent = (action: string, label?: string) => {
  const activeAccount = msalInstance.getActiveAccount();
  if (activeAccount?.localAccountId) {
    ReactGA.set({ userId: activeAccount.localAccountId, logged_in: true });
  } else {
    ReactGA.set({ userId: null, logged_in: false });
  }
  if (APIUrls.currentEnvironment === 'Prod') {
    ReactGA.event({ category: 'userAPI', action, label: label ?? activeAccount?.localAccountId ?? 'unauthenticated' });
  }
};

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  } else if (event.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
    if (event.error?.name === "InteractionRequiredAuthError" && window.location.pathname.startsWith(protectedResources.apiBapi.path)) {
    } else {
      console.log("ACQUIRE_TOKEN_FAILURE");
      trackAuthEvent('acquireTokenFailure', event.error?.name ?? 'unknown');
    }
  } else if (event.eventType === EventType.LOGIN_FAILURE) {
    // GA tracking for LOGIN_FAILURE lives in App.tsx's callback (same underlying
    // msalInstance), which distinguishes the password-reset case -- tracking it here
    // too would double-count every failure.
    if (event.error?.name === "BrowserAuthError" && window.location.pathname.startsWith(protectedResources.apiBapi.path)) {
    } else {
      console.log("LOGIN FAILURE");
    }
  } else {
    console.log("Callback finished");
  }
});
root.render(
  <React.StrictMode>
    <App pca={msalInstance}/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
